
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Container, Card, Button, InputGroup, OverlayTrigger, Tooltip } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import Select from 'react-select';
import { toast } from "react-toastify";

const FeeWaiverAllocation = () => {

  const [isEditable, setIsEditable] = useState(false);
  //const [ddlSection, setDdlSection] = useState([]);
  const [ddlYears, setDdlYears] = useState([]);
  const [ddlStudentList, setDdlStudentList] = useState([]);
  const [rowErrors, setRowErrors] = useState({});

  // Header State
  const [headerData, setHeaderData] = useState({
    year1: '',
  });

  // Child Table Data
  const [childRows, setChildRows] = useState([
    {
      irn: '',
      section_id: '',
      gr_no: '',
      stud_name: '',
      std_div: '',
      fw_desc: '',
      fw_status: '',
      fw_id: '',
    }
  ]);

  const handleHeaderChange = async (e) => {

    const { name, value } = e.target;
    setHeaderData(prev => ({ ...prev, [name]: value }));

    setChildRows([]);
    setChildRows([{ irn: '', section_id: '', gr_no: '', stud_name: '', std_div: '', fw_desc: '', fw_status: '', fw_id: '', }]);

    if (value) {
      const result = await axios.get(`${BASE_URL}/api/ddl_stud_name_revoke_fw`, {params: {p_year1 : value}});
      setDdlStudentList(result.data);
    }

  };

  // const handleChildChange = (index, e) => {
  //   const { name, value } = e.target;
  //   const updatedRows = [...childRows];
  //   updatedRows[index][name] = value;
  //   setChildRows(updatedRows);
  // };


  useEffect(() => {
    const fetchLists = async () => {
      try {

        const yearresult = await axios.get(`${BASE_URL}/api/ddl_years`);
        setDdlYears(yearresult.data);
        // const sectionresult = await axios.get(`${BASE_URL}/api/ddl_sections`);
        // setDdlSection(sectionresult.data);
      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };
    fetchLists();
  }, []);

  const addRow = () => {

    const newRow = { irn: '', section_id: '', gr_no: '', stud_name: '', std_div: '', fw_desc: '', fw_status: '', fw_id: '', };

    setChildRows([...childRows, newRow]);

  };

  const removeRow = (index) => {
    const updatedRows = [...childRows];
    updatedRows.splice(index, 1);
    setChildRows(updatedRows);
  };

  const handleNew = () => {

    setIsEditable(true);

    setHeaderData({ year1: '', });

  //  const newRow = { irn: '', section_id: '', gr_no: '', stud_name: '', std_div: '', fw_desc: '', fw_status: '', fw_id: '', };

//    setChildRows([...childRows, newRow]);

  };

  const handleSave = async () => {

    const errors = {};

    for (let i = 0; i < childRows.length; i++) {

      const row = childRows[i];

      // Validation
      if (!row.gr_no || row.gr_no === '') {
        errors[i] = { field: 'gr_no' };
        setRowErrors(errors);
        document.getElementById(`gr_no_${i}`)?.focus();
        toast.error(`Please select Student at Row # ${i + 1}`);
        return;
      }

    }

    // =========================
    // Duplicate Validation
    // =========================

    const rowSet = new Set();
    let key;

    for (let i = 0; i < childRows.length; i++) {

      key = `${childRows[i].section_id}_${childRows[i].gr_no}`;

      if (rowSet.has(key)) {
        errors[i] = { field: 'gr_no' };
        setRowErrors(errors);
        document.getElementById(`gr_no_${i}`)?.focus();
        toast.error(`Duplicate GR No. selected at Row # ${i + 1}`);
        return;
      }
      rowSet.add(key);
    }

    // clear errors if validation passed
    setRowErrors({});

    try {

      const isConfirmed = window.confirm("Fees Waiver will be revoked for the selected Student(s) ?");

      if (!isConfirmed) return;

      const revokedata = {
        header: headerData,
        details: childRows,
      };

      const response = await axios.post(`${BASE_URL}/api/revoke_fee_waiver`, revokedata);

      if (response.data.message === '1') {
         toast.success('Fee Waiver revoked successfully.');
         resetPage();
        //alert('Maintenance Structure saved successfully !');
      } 

    } catch (error) {
      toast.error('Error revoking Fee Waiver.' + error);
    }

  };

  const handleClear = () => {
    if (window.confirm("Clear all data?")) {
      resetPage();
      setIsEditable(false);
    }
  };

  const resetPage = () => {

    setIsEditable(false);
    setDdlStudentList([]);
    setHeaderData({  year1: '', });
    setChildRows([{ irn: '', section_id: '', gr_no: '', stud_name: '', std_div: '', fw_desc: '', fw_status: '', fw_id: '', }]);

  }

  // const handleGRNoChange = (index, selectedOption) => {    
  // }

  const handleGRNoChange = (index, selectedOption) => {

    if (!selectedOption) {
      const updatedRows = [...childRows];

      updatedRows[index] = {
        irn: '',
        section_id: '',
        gr_no: '',
        stud_name: '',
        std_div: '',
        fw_desc: '',
        fw_status: '',
        fw_id: '',
      };

      setChildRows(updatedRows);
      return;
    }

    const student = selectedOption.student;

    const updatedRows = [...childRows];

    updatedRows[index] = {
      ...updatedRows[index],
      irn: student.irn,
      section_id: student.section_id,
      gr_no: student.gr_no,
      stud_name: student.stud_name,
      std_div: student.std_div,
      fw_desc: student.fw_desc,
      fw_status: student.fw_status,
      fw_id: student.fw_id
    };

    setChildRows(updatedRows);

    setRowErrors({});

  };

  const studNameOptions = ddlStudentList.map(student => ({

    value: `${student.section_id}_${student.gr_no}`,
    label: student.stud_name,
    student

  })) || [];


  return (
    <Container fluid className="p-3">
      <Card className="mb-4 p-3">

        {<Row className="mb-3">

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "100px" }}>
                Year
              </InputGroup.Text>
              <select className="form-select" name="year1"
                value={headerData.year1} disabled={!isEditable}
                onChange={(e) => handleHeaderChange(e)} >
                <option value="">-- Select Year--</option>
                {ddlYears.map(year => (
                  <option key={year.year1} value={year.year1}>{year.disp_year}</option>
                ))}

              </select>
            </InputGroup>
          </Col>
        </Row>}

        <div className="d-flex justify-content-end gap-1 flex-wrap">

          <button
            type="button"
            className="btn btn-primary"
            style={{ width: "135px" }}
            onClick={handleNew}
            disabled={isEditable}
          >New
          </button>

          <button
            type="button"
            className="btn btn-secondary"
            style={{ width: "135px" }}
            onClick={handleClear}
          > Clear
          </button>

          <button
            type="button"
            className="btn btn-success"
            style={{ width: "135px" }}
            onClick={handleSave}
            disabled={!isEditable}
          > Save
          </button>
        </div>

      </Card>

      {/* Child Table */}
      <Card className="p-3">
        {/* <h5>Maintenance Items</h5> */}
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{ width: '4%', textAlign: 'center' }}>#</th>
                <th style={{ width: '35%', textAlign: 'left' }}>Student Name</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Std/Div</th>
                <th style={{ width: '8%', textAlign: 'left' }}>FW Status</th>
                <th style={{ width: '22%', textAlign: 'left' }}>Allocated Fee Waiver</th>
                <th style={{ width: '8%', textAlign: 'left' }}></th>
              </tr>
            </thead>

            <tbody>
              {childRows.map((row, index) => (
                <tr key={index}>
                  <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td>
                  <td>
                    {/* <input style={{ textAlign: 'right' }} disabled
                      type="text" className="form-control" name="stud_name" value={row.stud_name} onChange={(e) => handleChildChange(index, e)} /> */}
                    <Select name="gr_no"
                      inputId={`gr_no_${index}`} classNamePrefix="react-select"
                      className={rowErrors[index]?.field === 'gr_no' ? 'react-select-error' : ''}
                      options={studNameOptions}
                      //value={studNameOptions.find(option => String(option.value) === String(row.gr_no)) || null}
                      value={ studNameOptions.find( option => option.student.section_id === row.section_id &&
                                                      String(option.student.gr_no) === String(row.gr_no)) || null }
                      onChange={(selectedOption) => handleGRNoChange(index, selectedOption)}
                      isDisabled={!isEditable} 
                      placeholder="-- Select Student by GR No or Name --"
                      menuPortalTarget={document.body}
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} />
                  </td>
                  <td>{row.std_div} </td>
                  <td style={{color: row.fw_status === 'Approved' ? 'green' : 'blue',
                              fontWeight: '600', }}>
                    {row.fw_status} </td>
                  <td>{row.fw_desc} </td>

                  <td style={{ textAlign: 'center' }}>
                    {childRows.length > 1 && (
                      <Button variant="danger" onClick={() => removeRow(index)} size="sm">Delete</Button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* <div className="mb-3">
          <Button disabled={!isEditable} style={{ marginTop: '10px' }} variant="primary" onClick={addRow}>Add Row</Button>
        </div> */}

        <div className="d-flex justify-content-end mt-2">
          <OverlayTrigger placement="bottom"
            overlay={<Tooltip id="add-tooltip" style={{ backgroundColor: "#e9ecef" }}>Add Row</Tooltip>}>
            <Button variant="primary" onClick={addRow} 
              disabled={!isEditable}
              style={{ width: "45px", height: "45px", borderRadius: "50%", padding: "0", fontSize: "30px" }}> +
            </Button>
          </OverlayTrigger>
        </div>

      </Card>

      {/* Buttons */}
    </Container>
  );
};

export default FeeWaiverAllocation;
